import React from 'react';
import BaseBlock from './BaseBlock';

/**
 * InternshipBlock renders internship entries.
 */
export const InternshipBlock = ({ items = [] }) => {
  if (!items || items.length === 0) return null;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--spacing-item-mb, 12px)' }}>
      {items.map((job, idx) => (
        <BaseBlock
          key={idx}
          title={job.company || job.organization || ''}
          rightMeta={job.location || ''}
          subtitle={job.role || 'Intern'}
          subRightMeta={`${job.startDate || ''}${job.startDate && job.endDate ? ' – ' : ''}${job.endDate || ''}`}
          bullets={job.bullets || []}
          tags={job.technologies || job.tech || []}
        />
      ))}
    </div>
  );
};
export default InternshipBlock;
